<script lang="ts" setup>
import Layout from "@/Shared/Layout.vue";
import { Link, router } from "@inertiajs/vue3";
// import { route } from "ziggy-js";
import Cms from "@/components/Cms.vue";
import { ref, computed, inject } from "vue";

let location = ref(window.location.href)
let builderData = ref([]);

let searchParams = computed(()=>{
    return {
        "data.pageType.$eq": "Api"
    }
})

let route = inject('route');
let url = computed(()=>{

    let urlString = location.value?.replace(`${window.location.origin}/index`, "")
    urlString = urlString.replace("/preview", '')
    // if(urlString.includes("/api/developer/")) {
    //     return urlString.replace("/api/developer/", "")
    // } else {
        return urlString
    // }
})
let slugify = (text: string) => {
    return text.toString().toLowerCase()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        .replace(/\-\-+/g, '-')         // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '');            // Trim - from end of text
}
let links = computed(()=>{
    let urlLinks = builderData.value.map((item: any)=>{
    let urlLink = item.pageName == "About The Api" ? route('api.docs') : route('api.docs', {pageName: slugify(item.pageName)})
    let urlEnding = urlLink.replace(`${window.location.origin}/index`, "")
    urlEnding = urlEnding.replace("/preview", '')
    let isCurrent = url.value == urlEnding
    return {
        label: item.pageName,
        url: urlLink,
        current: isCurrent,
        section: item.section,
    }
})
    let map = new Map();
    map.set('Getting Started', []);
    map.set('Endpoints', []);
    map.set('Tools', []);
    return urlLinks.reduce((acc: any, link: any) => {
        if (!acc.has(link.section)) {
            acc.set(link.section, []);
        }
        let links = acc.get(link.section)
        links.push(link)
        acc.set(link.section, links);
        return acc;
    }, map);
})

router.on('success', (event)=>{
    location.value = event.detail.page.url.replace(/(index)\/(preview\/)?/, '')
})

</script>
<template>
    <Layout>
        <cms v-show="false" v-model="builderData" driver="builder" model="content-section" :readable-fields="['pageName']" is-data :search-params="searchParams" />
        <div class="api-settings">
            <div class="api-settings-nav">
                <Link :href="route('account.show')" class="api-settings-nav-backCta" aria-label="Back to Account">Back to Account</Link>
                <div class="api-settings-nav-list">
                    <span class="headline-s">Rothco API</span>
                    <span class="headline-xs">Getting Started</span>
                    <Link :class="{
                        current: link.current
                    }" v-for="(link, linkIndex) of links.get('Getting Started')" :href="link.url" :key="linkIndex">{{ link.label }}</Link>
                    <span class="headline-xs">Endpoints</span>
                    <Link :class="{
                        current: link.current
                    }" v-for="(link, linkIndex) of links.get('Endpoints')" :href="link.url" :key="linkIndex">{{ link.label }}</Link>
                    <span class="headline-xs">Tools</span>
                    <Link :class="{
                        current: link.current
                    }" v-for="(link, linkIndex) of links.get('Tools')" :href="link.url" :key="linkIndex">{{ link.label }}</Link>
                </div>
            </div>
            <div class="api-settings-nav-mobile">
                <div class="nav-selector bg-rothcoCream">
                    <details class="nav-selector__details">
                        <summary class="nav-selector__title">
                            API Portal Menu
                        </summary>
                        <div class="nav-selector__content">
                            <ul class="navlinks">
                                <li><span class="headline-xs">Getting Started</span></li>
                                <li><Link :class="{
                                    current: link.current
                                }" v-for="(link, linkIndex) of links.get('Getting Started')" :href="link.url" :key="linkIndex">{{ link.label }}</Link></li>
                                <li><span class="headline-xs">Endpoints</span></li>
                                <li><Link :class="{
                                    current: link.current
                                }" v-for="(link, linkIndex) of links.get('Endpoints')" :href="link.url" :key="linkIndex">{{ link.label }}</Link></li>
                                <li><span class="headline-xs">Tools</span></li>
                                <li><Link :class="{
                                    current: link.current
                                }" v-for="(link, linkIndex) of links.get('Tools')" :href="link.url" :key="linkIndex">{{ link.label }}</Link></li>
                            </ul>
                        </div>
                    </details>
                </div>
                <Link :href="route('account.show')" class="api-settings-nav-backCta" aria-label="Back to Account">Back to Account</Link>
            </div>

            <div class="api-settings-content-container">

                <slot></slot>
            </div>
        </div>  
    </Layout>

</template>